export default "__VITE_ASSET__BJk5vnur__"